import { MapPin, Navigation, Clock } from "lucide-react";
import { BUSINESS } from "../../lib/business";

export const Location = () => {
  return (
    <section
      id="location"
      data-testid="location-section"
      className="py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-10 items-stretch">
        <div className="lg:col-span-5 flex flex-col justify-center">
          <div className="overline">
            <span className="gold-divider mr-3 align-middle" />
            Visit our facility
          </div>
          <h2 className="font-serif-display text-4xl md:text-5xl text-[#1A1A1A] mt-6 leading-tight">
            Based in Sonipat.
            <br />
            Serving India & beyond.
          </h2>
          <p className="text-[#595959] mt-5 leading-relaxed">
            Our manufacturing unit sits inside HSIIDC Phase-III, Barhi
            Industrial Area — one of Haryana&apos;s largest planned industrial
            zones, giving us logistics access to Delhi NCR and pan-India
            distribution.
          </p>

          <div className="mt-8 border border-[#E5E5E5] divide-y divide-[#E5E5E5]">
            <div className="p-5 flex gap-4">
              <MapPin className="w-5 h-5 text-[#D4AF37] mt-0.5" />
              <div>
                <div className="overline text-[10px]">Address</div>
                <div className="text-[#1A1A1A] mt-1 leading-relaxed text-sm">
                  {BUSINESS.address}
                </div>
              </div>
            </div>
            <div className="p-5 flex gap-4">
              <Clock className="w-5 h-5 text-[#D4AF37] mt-0.5" />
              <div>
                <div className="overline text-[10px]">Hours</div>
                <div className="text-[#1A1A1A] mt-1 text-sm">
                  {BUSINESS.hoursShort}
                </div>
              </div>
            </div>
          </div>

          <a
            data-testid="location-directions"
            href={BUSINESS.mapsUrl}
            target="_blank"
            rel="noreferrer"
            className="btn-gold rounded-sm mt-6 inline-flex items-center justify-center gap-2 h-12 px-6 text-sm font-semibold tracking-wider w-full sm:w-auto self-start"
          >
            <Navigation className="w-4 h-4" />
            Get Directions
          </a>
        </div>

        <div className="lg:col-span-7">
          <div className="relative border border-[#E5E5E5] overflow-hidden h-[360px] md:h-[520px] bg-[#FAFAFA]">
            <iframe
              data-testid="location-map-iframe"
              title="White Bull Global location map"
              src={BUSINESS.mapEmbed}
              width="100%"
              height="100%"
              style={{ border: 0, filter: "grayscale(25%) contrast(1.02)" }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </section>
  );
};
